<template>

<div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

    <div v-if="loading" class="text-center py-3">
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <p v-else-if="results.length == 0" class="pt-3 text-center">No search history</p>

    <div v-else>
      <!-- Desktop -->
      <table class="table datatables-basic d-none d-md-table">
        <tbody>
          <tr v-for="(result, index) in results" :key="index.id">
            <td class="pl-3">
              <a
                :href="'http://ip-api.com/json/' + result.ip"
                target="_blank"
                class="iplink">{{ result.ip }}</a>
            </td>
            <td class="agent"><span :title="result.agent"><i :class="`${getAgentLogo(result.agent)} fa-2x logo`"></i></span></td>
            <td class="pl-3"><a :href="`/search/${result.query.toLowerCase()}`" target="_blank">{{result.query.toLowerCase()}}</a></td>
            <td class="pl-3">{{ result.city }}</td>
            <td class="pr-4">
              <img
                :src="'/images/flags/svg/' + getFlag(result.country)"
                class="country_flag"
                :title="result.country" />
            </td>
            <td class="text-nowrap">
              <timeago
                :datetime="result.created_at"
                :auto-update="60"
                :title="formatDateMoment(result.created_at)"></timeago>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Mobile -->
      <table class="table d-md-none">
        <thead class="thead-dark">
          <tr>
            <th class="first-left first-right text-center">IP • Country • Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(result, index) in results" :key="index">
            <td class="pl-2">
              <div>{{ result.query }}</div>
              <div>{{ result.ip }}</div>
              <div>{{ result.country }}</div>
              <div>
                <timeago
                  :datetime="result.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(result.created_at)"></timeago>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</div>
</template> 

<script>
export default {
  data() {
    return {
      results: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getResults();

    // Echo.private("results")
    //   .listen("NewResult", (event) => {
    //     this.getResults();
    //   });
  },

  methods: {

    getResults() {
      this.loading = true;

      axios.post(`/search-results`).then((response) => {
        this.results = response.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
a.iplink {
  font-weight: normal !important;
}
.logo {
  position: relative;
  top: 0px;
}
td.agent {
  text-align: center;
  width: 70px;
}
td.source {
  text-align: center;
  width: 60px;
}
</style>